import { render, staticRenderFns } from "./AlbumList.vue?vue&type=template&id=46d90900"
import script from "./AlbumList.vue?vue&type=script&lang=js"
export * from "./AlbumList.vue?vue&type=script&lang=js"
import style0 from "./AlbumList.vue?vue&type=style&index=0&id=46d90900&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports